import { FolderCopyOutlined } from "@mui/icons-material";
import { FC } from "react";
import {
  BulkInsertFooter,
  MuiBox,
  MuiButtonTertiary,
  MuiTypography,
} from "../../../../../components";
import PermissionWrapper from "../../../../../components/permissionWrapper/PermissionWrapper";
import { MODULE_PERMISSIONS } from "../../../../../helpers/constants";
import { useSiteCore } from "../../../../../hooks/useSiteCore";

import { BulkUploadStatusResponse } from "../../../../bulkCreateProgram/modelsAndSchema/Models";

import { bulkTransferSiteCoreKeys } from "../../../siteCore/SiteCoreKeys";
import { BulkTransferStatusPanel } from "../../bulkTransferStatusPanel/BulkTransferStatusPanel";
import { BulkTransferProcessWrapper } from "./BulkTransferProcess.style";

export interface BulkTransferProcessUploadProps {
  onRefresh: () => void;
  onNewBulkActivity: () => void;
  summaryData: BulkUploadStatusResponse;
  pageId: string;
  handleNavigateBack: () => void;
}

export const BulkTransferProcess: FC<BulkTransferProcessUploadProps> = ({
  onRefresh,
  onNewBulkActivity,
  summaryData,
  pageId,
  handleNavigateBack,
}) => {
  const { useFetchLabel } = useSiteCore();
  const getLabel = useFetchLabel(
    bulkTransferSiteCoreKeys.bulkParticipantSummary,
  );

  const recordStats = {
    total: {
      count: summaryData?.totalRecords,
      label: getLabel(bulkTransferSiteCoreKeys.totalNumberOfRecords),
    },
    processed: {
      count: summaryData?.processedRecords,
      label: getLabel(bulkTransferSiteCoreKeys.processedRecords),
    },
  };

  return (
    <BulkTransferProcessWrapper>
      <MuiBox className="main-container">
        <BulkTransferStatusPanel
          recordStatistics={recordStats}
          processName={summaryData?.processName}
          status={summaryData?.status}
          onRefresh={onRefresh}
        />

        <MuiTypography
          variant="h5Bold"
          component={"p"}
          className="processing-note"
          data-testid={`processing-note`}
        >
          {getLabel(
            bulkTransferSiteCoreKeys.yourParticipantRecordIsProcessingMessage,
          )}
        </MuiTypography>

        <PermissionWrapper permission={MODULE_PERMISSIONS.BULK_TRANSFER}>
          <MuiBox className="footer-button">
            <MuiButtonTertiary
              onClick={onNewBulkActivity}
              data-testid={"add-new-bulk-activity"}
            >
              <FolderCopyOutlined />
              {getLabel(bulkTransferSiteCoreKeys.addNewBulkLink)}
            </MuiButtonTertiary>
          </MuiBox>
        </PermissionWrapper>
      </MuiBox>
      <BulkInsertFooter
        pageId={pageId}
        showCloseButtonOnly
        handleNavigateBack={handleNavigateBack}
      />
    </BulkTransferProcessWrapper>
  );
};
